import { render, staticRenderFns } from "./UnconfirmedEvent.vue?vue&type=template&id=683f1b4f&scoped=true&"
import script from "./UnconfirmedEvent.vue?vue&type=script&lang=js&"
export * from "./UnconfirmedEvent.vue?vue&type=script&lang=js&"
import style0 from "./UnconfirmedEvent.vue?vue&type=style&index=0&id=683f1b4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f1b4f",
  null
  
)

export default component.exports